/**
 * Hides product slides/thumbnails that don't belong to the selected color.
 * A media item's color comes from (in priority order):
 *   1. data-variant="variant--<value>" - manual alt-text tag, set in Shopify admin
 *   2. data-variant-color="<value>" - auto-computed from per-color image position blocks
 * Media with neither attribute is always shown (shared/general product photos).
 */
(function () {
  function normalize(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function filterMedia(root, variant) {
    if (!root || !variant) return;

    var selectedValues = (variant.options || []).map(normalize);
    var activeMediaId = variant.featured_media ? String(variant.featured_media.id) : null;
    var activeThumbId = activeMediaId ? root.dataset.section + '-' + activeMediaId : null;
    var items = root.querySelectorAll('[data-variant], [data-variant-color]');

    items.forEach(function (el) {
      // The variant's own image (per Shopify's real variant data) must never be
      // hidden, even if the color-position heuristic below misjudges which
      // color a media item belongs to (e.g. on combined/aggregated listings
      // where per-color images aren't uploaded as contiguous blocks).
      if (
        activeMediaId &&
        (el.getAttribute('data-image-id') === activeMediaId || el.getAttribute('data-media-id') === activeThumbId)
      ) {
        el.classList.remove('variant-media--hidden');
        return;
      }

      var raw = el.getAttribute('data-variant');
      var value = raw
        ? normalize(raw.replace(/^variant--/i, ''))
        : normalize(el.getAttribute('data-variant-color'));
      var matches = selectedValues.indexOf(value) !== -1;
      el.classList.toggle('variant-media--hidden', !matches);
    });
  }

  function init(productInfo) {
    var initialData = productInfo.querySelector('[data-selected-variant]');

    if (initialData && initialData.textContent) {
      try {
        filterMedia(productInfo, JSON.parse(initialData.textContent));
      } catch (error) {
        /* no-op: malformed initial variant JSON */
      }
    }

    if (typeof subscribe !== 'function' || !window.theme || !theme.PUB_SUB_EVENTS) return;

    subscribe(theme.PUB_SUB_EVENTS.variantChange, function (event) {
      if (!event || !event.data || event.data.sectionId !== productInfo.dataset.section) return;
      filterMedia(productInfo, event.data.variant);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('product-info').forEach(init);
  });
})();
